import Vue from 'vue'
import Vuex from 'vuex'

import units from './modules/units.module'
import auth from './modules/auth.module'
import payments from './modules/payments.module'
import complaints from './modules/complaints.module'
import users from './modules/users.module'
import reservations from './modules/reservations.module'
import forms from './modules/forms.module'
import announcements from './modules/announcements.module'
import properties from './modules/properties.module'
import violations from './modules/violations.module'
import notifications from './modules/notifications.module'
import roles from './modules/roles.module'
import pdcs from './modules/pdcs.module'
import appBarNotifications from './modules/appBarNotifications.module'
import securityDeposits from './modules/securityDeposit.module'
import downPayments from './modules/downPayment.module'
import asyncJobs from './modules/asyncJobs.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    units,
    auth,
    payments,
    complaints,
    users,
    reservations,
    forms,
    announcements,
    properties,
    violations,
    notifications,
    roles,
    pdcs,
    appBarNotifications,
    securityDeposits,
    downPayments,
    asyncJobs
  }
})
